var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Loading,
    {
      staticClass: "c-loader-wrapper",
      attrs: {
        active: _setup.isLoading,
        "is-full-page": _vm.fullSize,
        "z-index": _vm.zIndex,
      },
      on: {
        "update:active": function ($event) {
          _setup.isLoading = $event
        },
      },
    },
    [
      _c("div", { staticClass: "loader-content" }, [
        _c("img", {
          staticClass: "loader-icon",
          attrs: {
            src: require("@/assets/images/loader.gif"),
            alt: "loader-icon",
          },
        }),
        _vm._v(" "),
        _c("h4", { staticClass: "loader-text" }, [_vm._v(_vm._s(_vm.text))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }